export default __webpack_public_path__ + "static/media/whyus.49a26e35.png";